export default __webpack_public_path__ + "static/media/product-detail-full-01.75b74c4e.jpg";